module.exports = __webpack_public_path__ + "static/IMG_2595-4ab950fb4f932dea07a847f56f586d4e.jpg";